"use client";

import { Box, Card, Link, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  title: string;
  description: string;
  icon: ReactNode;
  href?: string;
  ltr?: boolean;
  fillWidth?: boolean;
};
export default function ContactCard(props: Props) {
  return (
    <Card
      elevation={0}
      sx={{
        background: "transparent",
        "&:hover": {
          background: "linear-gradient(6.32deg, #FFF8F0, transparent)",
          "& .contact-icon-box ": {
            backgroundColor: "secondary.200",
            color: "secondary.main",
          },
        },
        minWidth: props.fillWidth ? "100%" : 200,
        maxWidth: props.fillWidth ? "100%" : 400,
        transition: "0.1s all",
        borderRadius: 3,
        p: 1,
        minHeight: "100%",
        // boxShadow: "3px 6px 24px -6px #E8D9CF29, -3px 0px 24px -6px #E8D9CF1F",
      }}
    >
      <Link underline="none" target="_blank" href={props.href}>
        <Stack spacing={1}>
          <Stack alignItems={"center"} direction={"row"} spacing={1}>
            <Box
              className="contact-icon-box"
              sx={{
                width: 32,
                height: 32,
                borderRadius: 2,
                color: "grey.400",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "grey.50",
              }}
            >
              {props.icon}
            </Box>
            <Typography variant="subtitle2">{props.title}</Typography>
          </Stack>
          <Typography variant="subtitle1" {...(props.ltr && { dir: "ltr", textAlign: "left" })}>
            {props.description}
          </Typography>
        </Stack>
      </Link>
    </Card>
  );
}
